import Image from "next/image";

// Define the customer type for TypeScript
type Customer = {
  name: string;
  image: string;
  story: string;
  color: string;
};

type CustomerCardProps = {
  customer: Customer;
};

const CustomerCard = ({ customer }: CustomerCardProps) => {
  return (
    <div className="bg-white rounded-2xl text-center w-full max-w-sm relative h-full flex flex-col">
      {/* Heart icon */}
      <div
        className="hidden sm:flex sm:absolute left-[1rem] sm:left-[1.5rem] w-[26px] h-[26px] sm:w-[46px] sm:h-[46px] rounded-full shadow-md bg-white items-center justify-center"
        style={{ zIndex: 10 }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill={customer.color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      </div>
      <div
        className="absolute sm:hidden left-[1rem] sm:[1.5rem] w-[26px] h-[26px] sm:w-[46px] sm:h-[46px] rounded-full shadow-md bg-white flex items-center justify-center"
        style={{ zIndex: 10 }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill={customer.color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      </div>

      <div className="mt-4 sm:mt-8 bg-[#FFFCF7] rounded-lg overflow-hidden border border-[#F2F2F2] shadow-[0px_0px_11.6px_-1px_rgba(186,186,186,0.25)] rounded-xl p-[1rem] flex flex-col sm:gap-[28px] flex-grow justify-between bg-white">
        {/* Story */}
        <div className="pt-[12px] sm:pt-[64px]">
          <p className="text-[#474646]  font-normal text-[0.75rem] md:text-sm  text-left">
            {customer.story}
          </p>
        </div>

        {/* Customer info */}
        <div className=" flex items-center gap-[0.5rem] md:[0.75rem]">
          <div className="hidden md:flex">
            <Image
              src={customer.image}
              alt={customer.name}
              width={46}
              height={46}
              className="rounded-full"
            />
          </div>
          <div className="flex md:hidden">
            <Image
              src={customer.image}
              alt={customer.name}
              width={26}
              height={26}
              className="rounded-full"
            />
          </div>
          <span className="text-[0.75rem] md:text-[1.25rem] font-[700] text-[#0B214A]">
            {customer.name}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomerCard;
